function normalizer(data) {
    const output = Object.assign({}, data);
    output.upload = null;
    return output;
}

function prepareForEdit(data) {
    // tags 
    data.tag = data.tag.map(t => {return {key: t.id, label: t.title}});
    return data;
}

export {
    normalizer,
    prepareForEdit
}


// WEBPACK FOOTER //
// ./src/containers/Stores/pipeline.js